import { useEffect, useState } from 'react';
import userInfo from 'hub-http/userInfo';
import { captureException } from '../utils/captureException';
const useUserHasScope = check => {
  const [hasScope, setHasScope] = useState(false);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    async function fetchScope() {
      try {
        setLoading(true);
        const {
          user
        } = await userInfo({
          cached: false
        });
        setHasScope(user.scopes.includes(check));
      } catch (err) {
        if (err instanceof Error) {
          captureException(err, ['useUserHasScope']);
        } else {
          captureException(new Error('Unknown error'), ['useUserHasScope']);
        }
      } finally {
        setLoading(false);
      }
    }
    void fetchScope();
  }, [check]);
  return {
    loading,
    hasScope
  };
};
export const useHasDataSharingContactReadScope = () => {
  return useUserHasScope('multi-account-data-sharing-contact-read');
};
export const useHasDataSharingCompanyReadScope = () => {
  return useUserHasScope('multi-account-data-sharing-company-read');
};